import React from 'react'
import PropTypes from 'prop-types'
import SidebarLink from '../SidebarLink/SidebarLink'
import {
  Icon
} from 'belle-js'
import sidebarStyles from './SidebarSubSection.module.scss'

const SidebarSubSection = (props) => {
  const {
    name,
    sectionComplete,
    to,
    styles
  } = props

  const icon = sectionComplete ? 'checked' : 'unchecked'
  const iconClasses = sectionComplete ? styles.complete : styles.incomplete
  return (
    <li className={styles.sidebarSection}>
      <Icon icon={icon} width={15} height={15} iconClasses={iconClasses} />
      <SidebarLink to={to} name={name} />
    </li>
  )
}

SidebarSubSection.propTypes = {
  name: PropTypes.string.isRequired,
  sectionComplete: PropTypes.bool,
  to: PropTypes.object.isRequired,
  styles: PropTypes.object
}

SidebarSubSection.defaultProps = {
  sectionComplete: false,
  styles: sidebarStyles
}

export default SidebarSubSection



// WEBPACK FOOTER //
// ./src/components/Onboarding/PWMSidebar/SidebarSubSection/SidebarSubSection.jsx